import { render } from "./birthday.vue?vue&type=template&id=506cf4c2&scoped=true&ts=true"
import script from "./birthday.vue?vue&type=script&lang=ts"
export * from "./birthday.vue?vue&type=script&lang=ts"

import "./birthday.vue?vue&type=style&index=0&id=506cf4c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506cf4c2"]])

export default __exports__